<script>
    import { Doughnut } from 'vue-chartjs'
    import { base_url } from "../../http";
    export default {
        extends: Doughnut,
        name: "paymentType",
        props: {
            // chartdata: Object,
            labels: Array,
            data: Array
        },
        data() {
            return {
                // loading: true,
                chartdata: {
                    labels: [],
                    datasets: [
                        {
                            label: "Тип оплаты",
                            data: [],
                            backgroundColor: [
                                "#FFDA83",
                                '#FF8373',
                                '#55D8FE'
                            ],
                            borderColor: [
                                "#FFDA83",
                                '#FF8373',
                                '#55D8FE'
                            ],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    // scales: {
                    //   yAxes: [{
                    //     ticks: {
                    //       beginAtZero: true
                    //     }
                    //   }]
                    // }
                }
            };
        },
        mounted() {
            this.chartdata.datasets[0].data = this.data;
            this.chartdata.labels = this.labels;
            this.renderChart(this.chartdata, this.options);
        },
        watch: {
            // "chartdata":
            //   {
            //     handler: function () {
            //       this.renderChart(this.chartdata, this.options);
            //     },
            //     deep: true
            //   },
            "data": function() {
                this.chartdata.datasets[0].data = this.data;
                this.chartdata.labels = this.labels;
                this.renderChart(this.chartdata, this.options);
            }
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/apps/report/paymentType.vue